import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Text, Link } from '@chakra-ui/react';

export interface NavLinkProps {
  to: string;
  isActive: boolean;
  children: React.ReactNode;
}

export const NavLink: React.FC<NavLinkProps> = ({ to, isActive, children }) => {
  return (
    <Link
      as={RouterLink}
      to={to}
      position="relative"
      p={4}
      textDecoration="none"
      aria-current={isActive ? 'page' : undefined}
      _hover={{
        bg: 'gray.50',
        textDecoration: 'none',
      }}
      _focus={{ textDecoration: 'none', outline: '2px solid', outlineColor: 'blue.500', outlineOffset: '2px' }}
      transition="background-color 0.2s"
    >
      {isActive && <Box position="absolute" top={0} left={0} right={0} h="5px" bg="green.500" />}
      <Text
        fontSize="sm"
        color={isActive ? 'gray.900' : 'gray.700'}
        _hover={{ fontWeight: 'bold' }}
      >
        {children}
      </Text>
    </Link>
  );
};

export default NavLink;
